import { render, staticRenderFns } from "./GetPaymentLink.vue?vue&type=template&id=6a3966e1&scoped=true&"
import script from "./GetPaymentLink.vue?vue&type=script&lang=js&"
export * from "./GetPaymentLink.vue?vue&type=script&lang=js&"
import style0 from "./GetPaymentLink.vue?vue&type=style&index=0&id=6a3966e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3966e1",
  null
  
)

export default component.exports